// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.countdown-timer {
    /* width: 600px; */
    /* height: 100px; */

    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.countdown-timer span {
    margin-left: 5px;
    margin-right: 5px;
}

@media(max-width: 480px){
    .countdown-timer{
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 10rem;
        font-size: 1.25rem;
        margin-top: -2rem;
        margin-bottom: 2rem;
        margin-right: 2rem;
    }
}



.two-numbers {
    width: 2ch;
}

.counter {
    color:#3985CB;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 1.5rem;
    border: 5px solid #3985CB;
    margin-left: 2rem;
    /* padding: 3rem; */
    background-color: #fff;
    min-width: 12rem;
    min-height: 12rem;
    box-shadow: 9px 11px 19px 0px rgba(0,0,0,0.65);
    -webkit-box-shadow: 9px 11px 19px 0px rgba(0,0,0,0.65);
    -moz-box-shadow: 9px 11px 19px 0px rgba(0,0,0,0.65);
}

@media(max-width:480px){
    .counter {
        margin-bottom: 0.5rem;
        min-width: 12rem;
        min-height: 7rem;
    }
}
.numberCounter{
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size: 5rem;
}

@media(max-width:480px){
    .numberCounter{
        font-size: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/CounterdownTimer/CountdownTimer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;;IAEnB,gDAAgD;IAChD,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;;;AAIA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,8CAA8C;IAC9C,sDAAsD;IACtD,mDAAmD;AACvD;;AAEA;IACI;QACI,qBAAqB;QACrB,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;AACA;IACI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".countdown-timer {\n    /* width: 600px; */\n    /* height: 100px; */\n\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n    font-size: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.countdown-timer span {\n    margin-left: 5px;\n    margin-right: 5px;\n}\n\n@media(max-width: 480px){\n    .countdown-timer{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        margin-top: 10rem;\n        font-size: 1.25rem;\n        margin-top: -2rem;\n        margin-bottom: 2rem;\n        margin-right: 2rem;\n    }\n}\n\n\n\n.two-numbers {\n    width: 2ch;\n}\n\n.counter {\n    color:#3985CB;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border-radius: 1.5rem;\n    border: 5px solid #3985CB;\n    margin-left: 2rem;\n    /* padding: 3rem; */\n    background-color: #fff;\n    min-width: 12rem;\n    min-height: 12rem;\n    box-shadow: 9px 11px 19px 0px rgba(0,0,0,0.65);\n    -webkit-box-shadow: 9px 11px 19px 0px rgba(0,0,0,0.65);\n    -moz-box-shadow: 9px 11px 19px 0px rgba(0,0,0,0.65);\n}\n\n@media(max-width:480px){\n    .counter {\n        margin-bottom: 0.5rem;\n        min-width: 12rem;\n        min-height: 7rem;\n    }\n}\n.numberCounter{\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n    font-size: 5rem;\n}\n\n@media(max-width:480px){\n    .numberCounter{\n        font-size: 2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
